import api from "./api";

export const fetchHelpTopics =
    async (
        page = 1,
        size = 50
    ) => {
        try {
            const response =
                await api.get(
                    `/help-topic-management/help_topics/?filter_field=is_published&filter_value=True&page=${page}&size=${size}`
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        ?.response
                        ?.data
                        ?.detail ||
                    "Failed to fetch help topics.",
            };
        }
    };